/**
 * Say that something about notifications went wrong where nobody would see it
 * (review of spec 135): a stream message that could not be read, one shaped
 * unlike the contract, a read/archive the service refused. The person sees a
 * toast or nothing; this is for whoever has to find out why.
 */
export function reportNotificationProblem(
  message: string,
  context: Record<string, unknown>,
): void {
  console.warn(`notifications: ${message}`, context);
}

/** A refusal that keeps what the service answered, for the report. */
export class NotificationRequestError extends Error {
  constructor(
    readonly action: string,
    readonly status: number,
  ) {
    super(`${action} refused with ${String(status)}`);
    this.name = 'NotificationRequestError';
  }
}
